import React from 'react';
import { IconType } from '@src/types/IconType';
import { Icon } from './Icon';

export const LoadingSpinner = ({
  className,
  dataTestId = 'svg-loading-spinner',
}: {
  className?: string;
  dataTestId?: string;
}): React.ReactElement => (
  <Icon
    type={IconType.Loading}
    className={`animate-reverse-spin h-12 w-12 mx-auto ${className ?? ''}`}
    data-testid={dataTestId}
  />
);
